import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { ICapacityEvaluationRepository } from '@/api/fe-api/domain/repositories/capacity-evaluation.repository';

export namespace GetLevels {
  export const key = (input: Input) => [
    'capacity-evaluation',
    'get-levels',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = ICapacityEvaluationRepository.GetLevelsInput;
  export type Output = ICapacityEvaluationRepository.GetLevelsOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.capacityEvaluation.getLevels(input),
    });
  }
}
